import { Context, Logger } from '@vue-storefront/core';
import { IUseRegoSearchRefs } from '@composables/src/useRegoSearch/types';
import { Params } from '@api-client/src/api/getVehiclesByRego';

const getVehiclesByRego =
  (context: Context, refs: IUseRegoSearchRefs) => async (params: Params) => {
    Logger.debug(`useRegoSearch/getRegoDetails`);

    try {
      refs.result.value = null;
      refs.error.value = null;
      refs.loading.value = true;
      const {
        $partsDb: { api },
      } = context;

      const response = await api.getVehiclesByRego(params);
      refs.result.value = response.result;
    } catch (error: any) {
      const status = error.response?.status;
      if (status === 404) {
        refs.result.value = [];
        return;
      }
      refs.error.value = new Error('Failed to get vehicles by Rego.');
      Logger.error(`useRegoSearch/getRegoDetails/error`, error);
    } finally {
      refs.loading.value = false;
    }
  };

export default getVehiclesByRego;
